<template lang="pug">
  .number-field.input-field
    label {{ label }}
    input(
      type="number"
      pattern="[0-9]*"
      :value="value"
      :placeholder="placeholder"
      :required="required"
      :min="min"
      :max="max"
      @input="$emit('input', Number($event.target.value))"
      @focus="$emit('focus')"
    )
    label.unit {{ unit }}
</template>

<style lang="scss" scoped>
.number-field {
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
}

label {
  @extend %label-text;
  margin-left: 17px;
  white-space: nowrap;
}

.unit {
  @extend %label-text;
  opacity: 0.9;
  margin-left: 0;
  margin-right: 16px;
}

input {
  height: 56px;
  width: 100%;
  @extend %input-text;
  margin-left: 20px;
  margin-right: 5px;
  text-align: right;
  font-size: 20px;
  line-height: 30px;
  opacity: 0.4;

  @include placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
}
</style>

<script>
export default {
  props: {
    label: { type: String },
    unit: { type: String, required: true },
    min: { type: Number },
    max: { type: Number },
    value: { type: Number },
    placeholder: { type: Number },
    required: { type: Boolean, default: true },
  },
}
</script>
